import { MaxLrAicCaseRunDetailReadModel, MaxLrCaseRunDetailReadModel, SentryCaseRunDetailReadModel } from "@app/api2/api";
import { BPBoxWithHeader } from "@app/components/React/Common/BPBoxWithHeader";
import { InfoBox } from "@app/components/React/Common/InfoBox";
import { toSci } from "@app/components/React/Common/Utils";
import React from "react";

interface ISystemsMLProps {
    model: MaxLrCaseRunDetailReadModel | MaxLrAicCaseRunDetailReadModel | SentryCaseRunDetailReadModel;
    forPrint?: boolean;
}

export const SystemsML: React.FunctionComponent<ISystemsMLProps> = (props) => {
    const getOrder = (likelihoodType) => {
        return likelihoodType == 'maximum' ? 1 : likelihoodType == 'bayes_unrestricted' ? 2 : 3;
    }
    const nca = props.model?.results && 'calculationResponses' in props.model?.results && props.model?.results['calculationResponses'].sort((x, y) => y.calculationId - x.calculationId).map(x => x.nonContrResult).find(x => x != null);

    return <>
        <BPBoxWithHeader forPrint={props.forPrint} header={window.translation.caseRunView.mlSystemRatio}>
            <InfoBox forPrint={props.forPrint} compact items={(props.model?.results?.systems ?? []).map(m => {
                return {
                    width: 7,
                    label: m.system,
                    description: toSci(m.likelihoodRatio, 4)
                };
            })}></InfoBox>
        </BPBoxWithHeader>

    </>;
};
